import Icon from '@/shared/assets/icons/canceledLead.svg?react'
import { BaseDialog } from '@/shared/components'

type Props = {
  isModalOpen: boolean
  onConfirm: () => void
}

export const CanceledOrder = ({ isModalOpen, onConfirm }: Props) => {
  return (
    <BaseDialog
      isVisible={isModalOpen}
      onClose={onConfirm}
      onStepBack={onConfirm}
      closeButtonName="Вернуться назад"
      xButton={false}
      iconTitle={<Icon className="mx-auto text-[var(--status-red-fill)]" />}
    >
      <p className="text-[20px] text-center mt-[-8px]">Спор отклонен</p>
    </BaseDialog>
  )
}
